import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { useFormik, Field, ErrorMessage, FormikProvider, FieldArray } from "formik";
import * as Yup from "yup";
import { FaTrash } from "react-icons/fa";
import MembersTable from "./MembersTable";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import Swal from "sweetalert2";
import { config } from "../CommonUtils/CommonURLS";
import { failureAlert, successAlert2 } from "../CommonUtils/SweetAlerts";
const TrustNameAddressChange = () => {
    const [selectedMemberType, setSelectedMemberType] = useState("chairperson");
    const [changeType, setChangeType] = useState("");
    const [alreadySubmitted, setAlreadySubmitted] = useState(false);
    const formik = useFormik({
        initialValues: {
            natureOfChange: "",
            currentName: "",
            proposedName: "",
            currentAddress: "",
            newAddress: "",
            reason: "",
            Chairperson: [{
                name: "",
                address: "",
                mobile: "",
                role: "",
                responsibilities: ""
            }],

            Members: [{
                name: "",
                address: "",
                mobile: "",
                role: "",
                responsibilities: ""
            }]
        },
        validationSchema: Yup.object({

            // natureOfChange: Yup.string()
            //     .required("Select Nature of Change"),

            currentName: Yup.string()
                .required("Enter Current Name"),

            proposedName: Yup.string()
                .required("Enter Proposed Name")
                .notOneOf(
                    [Yup.ref("currentName")],
                    "Proposed name should be different from current name"
                ),

            currentAddress: Yup.string()
                .when("natureOfChange", {
                    is: "address",
                    then: (schema) => schema.required("Enter Current Address")
                }),

            // newAddress: Yup.string()
            //     .when("natureOfChange", {
            //         is: "address",
            //         then: (schema) => schema.required("Enter New Address")
            //     }),

            reason: Yup.string()
                .min(10, "Reason must be at least 10 characters")
                .required("Enter Reason"),

            Chairperson: Yup.array().of(
                Yup.object().shape({
                    name: Yup.string()
                        .required("Enter Name"),

                    address: Yup.string()
                        .required("Enter Address"),

                    mobile: Yup.string()
                        .matches(/^[0-9]{10}$/, "Enter valid 10 digit mobile")
                        .required("Enter Mobile Number"),

                    role: Yup.string()
                        .required("Enter Role"),

                    responsibilities: Yup.string()
                        .required("Enter Responsibilities")
                })
            ),

            Members: Yup.array().of(
                Yup.object().shape({
                    name: Yup.string()
                        .required("Enter Name"),

                    address: Yup.string()
                        .required("Enter Address"),

                    mobile: Yup.string()
                        .matches(/^[0-9]{10}$/, "Enter valid 10 digit mobile")
                        .required("Enter Mobile Number"),

                    role: Yup.string()
                        .required("Enter Role"),

                    responsibilities: Yup.string()
                        .required("Enter Responsibilities")
                })
            )
        }),
        onSubmit: (values) => {
            handleSubmit(values);
        }
    });
    const [getSocietyNameChange, setSocietyNameChange] = useState([])
    const getTrustDetails = async () => {

        let url = config.url.FAC_URL + "getSocietyNameChange";

        CommonAxiosGet(url).then((res) => {

            if (res !== null && res.data.status === true) {

                let societyData = res.data.societyName;
                let chairPersons = res.data.chairPerson;
                let boardMembers = res.data.boardOfGoverners;

                let societyStatus = res.data.societyName_status;
                let chairStatus = res.data.chairPerson_status;
                let boardStatus = res.data.boardOfGoverners_status;

                // ✅ If ANY data exists → disable form
                if (societyStatus || chairStatus || boardStatus) {

                    setAlreadySubmitted(true);

                    if (societyStatus) {

                        let society = societyData[0];

                        const changeType =
                            society.name_address_change === "Name Change"
                                ? "name"
                                : "address";

                        setChangeType(society.name_address_change);

                        formik.setFieldValue("natureOfChange", changeType);
                        formik.setFieldValue("currentName", society.current_name_of_trust);
                        formik.setFieldValue("proposedName", society.proposed_new_name);
                        formik.setFieldValue("currentAddress", society.current_address);
                        formik.setFieldValue("newAddress", society.new_address);
                        formik.setFieldValue("reason", society.reason_for_change);
                    }

                    // Chairperson
                    if (chairStatus) {

                        const chairData = chairPersons.map((item) => ({
                            name: item.name_of_chairperson,
                            address: item.address,
                            mobile: item.contact,
                            role: item.role,
                            responsibilities: item.responsibilities
                        }));

                        formik.setFieldValue("Chairperson", chairData);
                    }

                    // Board Members
                    if (boardStatus) {

                        const membersData = boardMembers.map((item) => ({
                            name: item.name_of_chairperson,
                            address: item.address,
                            mobile: item.contact,
                            role: item.role,
                            responsibilities: item.responsibilities
                        }));

                        formik.setFieldValue("Members", membersData);
                    }

                } else {

                    // ✅ No data anywhere → allow submit
                    setAlreadySubmitted(false);

                }
            }
        });
    };
    useEffect(() => {
        getTrustDetails();
        getBasicDetails();
    }, []);
    const [getBasicData, setBasicData] = useState([])
    function getBasicDetails() {
        let url = config.url.FAC_URL + "getSocietyDetails";
        CommonAxiosGet(url).then((res) => {
            if (res !== null && res.data.status === true) {
                let data = res.data.data;
                if (data && data.length > 0) {
                    let item = data[0];
                    formik.setFieldValue("currentName", item.society_name);
                    formik.setFieldValue("currentAddress", item.society_addr);
                    if (item.society_name || item.society_addr) {
                        setAlreadySubmitted(true);
                    } else {
                        setAlreadySubmitted(false);
                    }

                    setAlreadySubmitted(true);
                } else {
                    setAlreadySubmitted(false);
                }
            } else {
                setAlreadySubmitted(false);
            }
        });

    }
    const handleSubmit = (values) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to submit ?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#1d2b3a",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Submit",
            cancelButtonText: "Cancel"
        }).then((result) => {
            if (result.isConfirmed) {
                const payload = {
                    nameAddressChange: values.natureOfChange === "name" ? "Name Change" : "Address Change",
                    currentNameOfTrust: values.currentName,
                    proposedNewName: values.proposedName,
                    reasonForChange: values.reason,
                    newAddress: values.newAddress,
                    currentAddress: values.currentAddress,
                    chairPerson: values.Chairperson.map((item) => ({
                        nameOfChairperson: item.name,
                        address: item.address,
                        contact: item.mobile,
                        role: item.role,
                        responsibilities: item.responsibilities
                    })),
                    governer: values.Members.map((item) => ({
                        nameOfChairperson: item.name,
                        address: item.address,
                        contact: item.mobile,
                        role: item.role,
                        responsibilities: item.responsibilities
                    }))
                };
                let url = config.url.FAC_URL + "postSocietyName";
                CommonAxiosPost(url, payload)
                    .then((res) => {
                        if (res !== null && res.data) {
                            if (res.data.scode === "01") {
                                Swal.fire({
                                    icon: "success",
                                    title: "Success",
                                    text: res.data.sdesc,
                                    confirmButtonColor: "#1d2b3a"
                                }).then(() => {
                                    window.location.reload();
                                });
                            }
                        } else {
                            failureAlert(res.data.sdesc);
                        }
                    })
                    .catch((error) => {
                        console.error("Submit Error:", error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: error.message,
                            confirmButtonColor: '#1d2b3a'
                        });
                    });
            }
        });
    };

    return (
        <>
            {/* </Card.Header> */}
            {/* <Card.Body> */}
            <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                    {/* Nature of Change */}
                    {/* <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="mb-2">
                            <Form.Label className="fw-bold">
                                Nature of Change (Choose the change you wish to request) <span style={{ color: "red" }}>*</span>
                            </Form.Label>
                        </Col>

                        <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3} className="mb-1">

                            <div className="border rounded p-3">
                                <Field
                                    type="radio"
                                    name="natureOfChange"
                                    value="name"
                                    className="form-check-input"
                                    disabled={alreadySubmitted}
                                  
                                />
                                <label className="ms-2">
                                    🏷 <b>Name Change</b>
                                </label>
                                <div style={{ fontSize: "13px", color: "#6c757d" }}>
                                    Change in Trust / Society name
                                </div>
                            </div>
                        </Col>
                     
                        <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3} className="mb-1">
                            <div className="border rounded p-3">
                                <Field
                                    type="radio"
                                    name="natureOfChange"
                                    value="address"
                                    className="form-check-input"
                                    disabled={alreadySubmitted}
                                  
                                />
                                <label className="ms-2">
                                    🏠 <b>Address Change</b>
                                </label>
                                <div style={{ fontSize: "13px", color: "#6c757d" }}>
                                    Change in registered address
                                </div>
                            </div>
                        </Col>
                        <ErrorMessage
                            name="natureOfChange"
                            component="div"
                            className="text-danger"
                        />
                    </Row> */}
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3 d-flex flex-column">
                            <Form.Label >
                                Change in the Name of the Institution/ Trust/Society/Company <span style={{ color: "red" }}>*</span>
                            </Form.Label>
                            <Field
                                type="text"
                                name="currentName"
                                className="form-control"
                                disabled

                            />
                            <ErrorMessage
                                name="currentName"
                                component="div"
                                className="text-danger"
                            />
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3 d-flex flex-column">
                            <Form.Label>
                                Proposed New Name <span style={{ color: "red" }}>*</span>
                            </Form.Label>
                            <Field
                                type="text"
                                name="proposedName"
                                className="form-control"
                                disabled={alreadySubmitted}

                            />
                            <ErrorMessage
                                name="proposedName"
                                component="div"
                                className="text-danger"
                            />
                        </Col>

                        <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3 d-flex flex-column">
                            <Form.Label>
                                Current Registered Address  of Trust/Society/Company
                            </Form.Label>
                            <Field
                                type="text"
                                name="currentAddress"
                                className="form-control"
                                disabled

                            />
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3 d-flex flex-column">
                            <Form.Label>
                                New Address (if changed)
                            </Form.Label>
                            <Field
                                type="text"
                                name="newAddress"
                                className="form-control"
                                disabled={alreadySubmitted}

                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                            <Form.Label>
                                <b> Reason for Change <span style={{ color: "red" }}>*</span></b>
                            </Form.Label>
                            <Field
                                name="reason"
                                as="textarea"
                                rows={4}

                                placeholder="Please provide detailed justification for the change..."
                                className={`form-control ${formik.touched.justification && formik.errors.justification ? 'is-invalid' : ''}`}
                                style={{ height: "120px", resize: "vertical" }}
                                disabled={alreadySubmitted}
                            />
                            <ErrorMessage name="reason" component="div" className="text-danger" />
                        </Col>
                    </Row>
                    <h5 className="mb-3 innerheader-new"><span><b>Chairperson / Members of Trust/Society/Company</b></span></h5>
                    <MembersTable
                        title="Chairperson / Members of Trust/Society/Company"
                        name="Chairperson"
                        formik={formik}
                        disabled={alreadySubmitted}
                    />
                    <h5 className="mb-3 innerheader-new"><span><b>Board of Governors</b></span></h5>
                    <MembersTable
                        title="Board of Governors"
                        name="Members"
                        formik={formik}
                        disabled={alreadySubmitted}
                    />
                    {/* <Row className="mt-4">
                        <Col className="text-end">
                            <Button
                                type="submit"
                                variant="primary"
                                className="btn-primary"
                            // style={{ background: "#1d2b3a", border: "none", padding: "10px 30px" }}
                            >
                                Submit
                            </Button>
                        </Col>
                    </Row> */}
                    {alreadySubmitted ? (
                        <div className="text-success text-end mt-4 ">
                            ✔ Your request has already been submitted for this academic year.
                        </div>
                    ) : (
                        <Row className="mt-4">
                            <Col className="text-end">
                                <Button
                                    type="submit"
                                    variant="primary"
                                    className="btn-primary"
                                >
                                    Submit
                                </Button>
                            </Col>
                        </Row>
                    )}
                    {/* )} */}
                </Form>
            </FormikProvider>
            {/* </Card.Body > */}
            {/* // </Card> */}
            {/* // </Container> */}
        </>
    );
};
export default TrustNameAddressChange;